import { render, staticRenderFns } from "./corporate-culture.vue?vue&type=template&id=7515b969&scoped=true&"
import script from "./corporate-culture.vue?vue&type=script&lang=js&"
export * from "./corporate-culture.vue?vue&type=script&lang=js&"
import style0 from "./corporate-culture.vue?vue&type=style&index=0&id=7515b969&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7515b969",
  null
  
)

export default component.exports